import { useId } from 'react'

import * as RadioGroupPrimitive from '@radix-ui/react-radio-group'
import type { VariantProps } from 'class-variance-authority'
import { cva } from 'class-variance-authority'
import { twMerge } from 'tailwind-merge'

const radioButtonVariants = cva(
  'cursor-pointer border border-border-secondary bg-card transition-colors dark:bg-secondary-700 hover:dark:border-secondary-200 hover:dark:bg-secondary-600 hover:border-secondary-500 hover:bg-secondary-50 data-[state=checked]:border-2 data-[state=checked]:border-primary-500 data-[state=checked]:dark:bg-secondary-600 data-[state=checked]:bg-secondary-50',
  {
    variants: {
      variant: {
        full: 'w-full rounded-lg p-4',
        small: 'rounded-full px-4 py-2',
      },
    },
    defaultVariants: {
      variant: 'small',
    },
  },
)

type Props = React.ComponentPropsWithoutRef<typeof RadioGroupPrimitive.Item> &
  VariantProps<typeof radioButtonVariants>

export const RadioButton = ({
  children,
  variant,
  className,
  ...props
}: Props) => {
  const baseId = useId()

  const combinedClassName = twMerge(radioButtonVariants({ variant }), className)

  return (
    <RadioGroupPrimitive.Item
      {...props}
      className={combinedClassName}
      id={baseId}
    >
      <div className="flex items-center gap-2 leading-[26px] text-title">
        {children}
      </div>
    </RadioGroupPrimitive.Item>
  )
}
